import { RouteHelpers } from '@/mixins';
import { FindDocument } from '@/types';

const documents = () => import('@/views/FindDocument.vue');

const documentComponents = {
  findDocument: FindDocument
};

export const FindDocumentsRoutes = [
  {
    ...FindDocument.FindDocument,
    component: documents,
    meta: {
      title: 'Find Document'
    }
  }
];
